import CommandTypes from '../types';
import PlaceholderValidator from './validators/PlaceholderValidator';

export default {
    [CommandTypes.CREATE_SHAPES]: [
        new PlaceholderValidator()
    ]
};
